export const G = `
*{box-sizing:border-box;margin:0;padding:0}
html,body{font-family:'Plus Jakarta Sans',system-ui,sans-serif;background:#010810;color:#DCE4E8;-webkit-font-smoothing:antialiased}
h1,h2,h3,h4{font-family:'Plus Jakarta Sans',sans-serif;font-weight:800;line-height:1.05;letter-spacing:-.025em}
p{margin:0}a{color:inherit;text-decoration:none}button,input,textarea{font-family:inherit}
::selection{background:rgba(15,163,177,.3)}
::-webkit-scrollbar{width:5px}::-webkit-scrollbar-thumb{background:#1A3550;border-radius:3px}
.chrome{background:linear-gradient(135deg,#1FC8D6 0%,#fff 42%,#0FA3B1 68%,#1FC8D6 100%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}
.chrome-ink{background:linear-gradient(176deg,#2b4350 0%,#0f2730 50%,#355663 100%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;padding-bottom:0.14em}
.wrap{width:100%;max-width:1240px;margin:0 auto;padding:0 28px}
.wrap-hero{width:100%;max-width:1500px;margin:0 auto;padding:0 36px}
.sec{padding:100px 0}
.sec-head{text-align:center;margin-bottom:52px}
.eb{display:inline-flex;align-items:center;gap:8px;font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:.22em;text-transform:uppercase;color:#1FC8D6;font-weight:600}
.eb::before,.eb::after{content:'';width:18px;height:1px;background:currentColor;opacity:.55}
.eb.light{color:#0A7B86}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:'Plus Jakarta Sans',sans-serif;font-weight:700;font-size:15px;border:none;border-radius:999px;padding:14px 26px;cursor:pointer;transition:background .22s,box-shadow .22s,border-color .22s,color .22s,transform .12s;line-height:1;white-space:nowrap}
.btn:active{transform:scale(.97)!important}
.btn-p{background:linear-gradient(175deg,#1FC8D6,#0A7B86);color:#03252a;box-shadow:0 6px 22px rgba(15,163,177,.28),inset 0 1px 0 rgba(255,255,255,.22)}
.btn-p:hover{background:linear-gradient(175deg,#28DDE8,#0D96A8);box-shadow:0 8px 30px rgba(15,163,177,.52),inset 0 1px 0 rgba(255,255,255,.3)}
.btn-g{background:rgba(255,255,255,.06);color:#DCE4E8;border:1px solid #122840}
.btn-g:hover{background:rgba(255,255,255,.11);border-color:rgba(31,200,214,.45);color:#fff}
.btn-ol{background:transparent;color:#0A2028;border:1.5px solid rgba(10,32,40,.18)}
.btn-ol:hover{border-color:#0FA3B1;color:#0A7B86}
.btn-lg{padding:17px 34px;font-size:16px}
.card-l{background:#fff;border:1px solid rgba(10,32,40,.06);border-radius:20px;box-shadow:0 2px 8px rgba(6,32,46,.06),0 16px 40px rgba(6,32,46,.08)}
.inp-wrap{position:relative}

/* ── Keyframes ── */
@keyframes shimmer{0%,100%{opacity:.45}50%{opacity:.88}}
@keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes floatY{0%,100%{transform:translate(-50%,-50%)}50%{transform:translate(-50%,-62%)}}
@keyframes scrollLine{0%,100%{opacity:.35;transform:scaleY(.6)}50%{opacity:1;transform:scaleY(1)}}
@keyframes bubbleFloat{0%{transform:translateY(0) scale(1);opacity:0}8%{opacity:1}88%{opacity:.65}100%{transform:translateY(-105vh) scale(.5);opacity:0}}
@keyframes bubbleDrift{0%,100%{transform:translateX(0)}33%{transform:translateX(7px)}66%{transform:translateX(-5px)}}
@keyframes ringAnim{0%{box-shadow:0 0 0 0 rgba(15,163,177,.45)}70%{box-shadow:0 0 0 12px rgba(15,163,177,0)}100%{box-shadow:0 0 0 0 rgba(15,163,177,0)}}
@keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
@keyframes wlMenuIn{from{opacity:0;transform:translateY(-10px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}
@keyframes gridPulse{0%,100%{transform:scale(1);opacity:.7}50%{transform:scale(1.06);opacity:.95}}
@keyframes bentoGridShimmer{0%,100%{opacity:.3}50%{opacity:.7}}
@keyframes glowPulse{0%,100%{box-shadow:0 0 14px rgba(31,200,214,.12),0 0 0 2px rgba(31,200,214,.2)}50%{box-shadow:0 0 26px rgba(31,200,214,.28),0 0 0 2px rgba(31,200,214,.4)}}
@keyframes waveIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
@keyframes countUp{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
@keyframes ctaGridPulse{0%,100%{opacity:.42}50%{opacity:.9}}

.wl-drop-item{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;border-radius:10px;border:none;background:transparent;cursor:pointer;text-align:left;font-family:'Plus Jakarta Sans',sans-serif;transition:background .15s}
.wl-drop-item:hover{background:rgba(255,255,255,.07)}

/* ── Hero full-viewport ── */
.hero-sec{position:relative;background:#040D18;min-height:100svh;min-height:100vh;padding-top:78px;padding-bottom:90px;display:flex;flex-direction:column;justify-content:center;overflow:hidden}
.hero-inner{position:relative;z-index:2;padding:20px 0 60px}
.hero-3col{display:grid;grid-template-columns:.58fr 1.22fr .88fr;gap:30px;align-items:stretch}
.hero-copy-wrap{display:flex!important;align-items:center}
.hero-copy-inner{width:100%;min-width:0}
.hero-col-card{height:100%;display:flex;flex-direction:column}
.hero-eq-body{flex:1;overflow:hidden}
.hero-canvas-wrap{height:clamp(260px,calc(100vh - 520px),460px);min-height:260px;position:relative}
.hero-scroll{position:absolute;bottom:26px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:30px;font-family:'JetBrains Mono',monospace;font-size:12px;letter-spacing:.2em;color:#1A3F52;pointer-events:none;z-index:3;white-space:nowrap}
@media(min-width:1500px){
  .hero-3col{gap:44px}
  .hero-canvas-wrap{height:clamp(340px,calc(100vh - 500px),540px)}
}
@media(max-width:1340px){
  .hero-3col{grid-template-columns:.64fr 1.16fr .88fr;gap:22px}
}
.hero-badge{white-space:nowrap}
@media(max-width:820px){
  .hero-badge{white-space:normal;justify-content:center;font-size:9px!important;letter-spacing:.18em!important}
  .hero-badge::before,.hero-badge::after{display:none!important}
}
@media(max-width:1100px){
  .hero-3col{grid-template-columns:1fr 1fr;gap:18px}
  .hero-copy-wrap{grid-column:span 2}
  .hero-canvas-wrap{height:clamp(220px,38vw,340px)}
  .hero-inner{padding:16px 0 52px}
  .hero-copy-inner{align-items:center!important;text-align:center}
  .hero-btns{justify-content:center!important}
  .hero-stats{justify-content:center!important}
}
@media(max-width:1080px){
  .nav-links,.nav-cta-d,.nav-user-wrap{display:none!important}.burger{display:flex!important}
  .g3{grid-template-columns:repeat(2,1fr)!important}
  .g4{grid-template-columns:repeat(2,1fr)!important}
  .g-about{grid-template-columns:1fr!important}
  .g-faq{grid-template-columns:1fr!important}
  .step-arr{display:none!important}
  .ftr-g{grid-template-columns:1fr 1fr!important}
}
@media(max-width:820px){
  .hero-sec{padding-bottom:60px}
  .hero-3col{grid-template-columns:1fr;gap:14px;align-items:start}
  .hero-copy-wrap{display:block!important;grid-column:unset}
  .wrap-hero{padding:0 20px!important}
  .hero-inner{padding:12px 0 50px}
  .hero-canvas-wrap{height:clamp(200px,52vw,300px)}
  .hero-scroll{bottom:22px;gap:26px}
  .hero-copy-inner{align-items:center!important;text-align:center}
  .hero-btns{justify-content:center!important}
  .hero-stats{justify-content:center!important}
  .hero-col-card{height:auto;max-width:500px;margin:0 auto;width:100%}
  .hero-eq-body{flex:none}
}
@media(max-width:680px){
  .sec{padding:68px 0!important}.wrap{padding:0 18px!important}.wrap-hero{padding:0 16px!important}
  .g3,.g4,.g-faq,.ftr-g{grid-template-columns:1fr!important}
  .cta-row{flex-direction:column!important;align-items:center!important}
}
@media(max-width:560px){
  .hero-sec{padding-bottom:50px}
  .wrap-hero{padding:0 14px!important}
  .hero-inner{padding:8px 0 44px}
  .hero-canvas-wrap{height:clamp(180px,58vw,250px)}
  .hero-scroll{bottom:18px;gap:22px;font-size:11px}
  .nav-user-name{display:none!important}
  .nav-user-chevron{display:none!important}
  .nav-user-btn{padding:3px!important;width:42px!important;height:42px;border-radius:12px!important;justify-content:center}
  .hero-stats{gap:10px!important}
}
@media(max-width:380px){
  .hero-canvas-wrap{height:clamp(160px,55vw,220px)}
}
.burger{display:none}
@media(max-width:1080px){.burger{display:flex!important;align-items:center}}

/* ── Gallery grid ── */
.gal-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
.gal-span2{grid-column:span 2}
@media(max-width:900px){.gal-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:560px){.gal-grid{grid-template-columns:1fr!important}.gal-span2{grid-column:unset!important}}

/* ── Gallery hover CTA overlay ── */
.gal-thumb-wrap{position:relative;overflow:hidden}
.gal-hover-cta{position:absolute;inset:0;display:flex;align-items:flex-end;justify-content:center;padding:20px;opacity:0;transition:opacity .32s ease;background:linear-gradient(to top,rgba(4,13,24,.88) 0%,rgba(4,13,24,.32) 55%,transparent 100%);z-index:2}
.gal-thumb-wrap:hover .gal-hover-cta{opacity:1}
.gal-hover-btn{background:rgba(31,200,214,.16);border:1px solid rgba(31,200,214,.55);color:#1FC8D6;font-family:'Plus Jakarta Sans',sans-serif;font-weight:700;font-size:13px;padding:10px 22px;border-radius:999px;cursor:pointer;transition:background .2s,border-color .2s,box-shadow .2s;white-space:nowrap;backdrop-filter:blur(10px);display:inline-flex;align-items:center;gap:7px;transform:translateY(6px);transition:background .22s,border-color .22s,transform .32s ease}
.gal-thumb-wrap:hover .gal-hover-btn{transform:translateY(0)}
.gal-hover-btn:hover{background:rgba(31,200,214,.3);border-color:#1FC8D6;box-shadow:0 0 18px rgba(31,200,214,.25)}

/* ── Reviews ── */
.rev-outer{display:flex;align-items:center;gap:14px}
.rev-grid{flex:1;display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.rev-sidenav{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.7);border:1px solid #D1DCE8;color:#3C5468;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .22s}
.rev-sidenav:hover{background:#fff;border-color:#0FA3B1;color:#0A7B86}
.rev-dotsrow{display:flex;justify-content:center;gap:6px;margin-top:22px}
.rev-botnav{display:none;justify-content:center;align-items:center;gap:18px;margin-top:20px}
.rev-botnav-btn{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.7);border:1px solid #D1DCE8;color:#3C5468;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .22s}
.rev-botnav-btn:hover{background:#fff;border-color:#0FA3B1;color:#0A7B86}
@media(max-width:820px){
  .rev-outer{flex-direction:column;gap:0}
  .rev-grid{width:100%;grid-template-columns:repeat(2,1fr)}
  .rev-sidenav-wrap{display:none!important}
  .rev-botnav{display:flex}
  .rev-dotsrow{display:none}
}
@media(max-width:560px){.rev-grid{grid-template-columns:1fr}}

/* ── Chrome-bright gradient text ── */
.chrome-bright{background:linear-gradient(128deg,#0E7490 0%,#06B6D4 36%,#67E8F9 70%,#CFFAFE 100%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;display:inline-block;padding-bottom:0.14em}

/* ── Bento Grid (Features) ── */
.bento{display:grid;grid-template-columns:1.15fr 1fr 1fr;grid-template-rows:auto auto auto;gap:16px}
.bento-hero{grid-column:1;grid-row:1/3;min-height:380px;position:relative;overflow:hidden;background:#050F1E;border:1px solid rgba(31,200,214,.14);border-radius:20px;cursor:default}
.bento-full{grid-column:1/4;border-radius:20px}
.bento-cell{border-radius:18px;border:1px solid rgba(10,32,40,.07);background:#fff;transition:transform .3s ease,box-shadow .25s,border-color .25s;position:relative;overflow:hidden}
.bento-hero{transition:transform .3s ease}
.bento-cell:hover{box-shadow:0 12px 40px rgba(6,32,46,.14);border-color:rgba(10,123,134,.22)}
.bento-dark{background:#0A1B2E!important;border-color:#122840!important}
.bento-dark:hover{border-color:rgba(31,200,214,.35)!important;box-shadow:0 8px 32px rgba(0,0,0,.4),0 0 0 1px rgba(31,200,214,.12)!important}
@media(max-width:1080px){
  .bento{grid-template-columns:1fr 1fr}
  .bento-hero{grid-column:1/3;grid-row:auto;min-height:240px}
  .bento-full{grid-column:1/3}
}
@media(max-width:560px){
  .bento{grid-template-columns:1fr}
  .bento-hero{grid-column:1;min-height:200px}
  .bento-full{grid-column:1}
}

/* ── Steps Timeline ── */
.steps-tl{display:grid;grid-template-columns:repeat(5,1fr);gap:0;position:relative}
.steps-tl::before{content:'';position:absolute;top:19px;left:10%;right:10%;height:1px;background:linear-gradient(90deg,transparent,rgba(31,200,214,.3) 15%,rgba(31,200,214,.3) 85%,transparent);z-index:0;pointer-events:none}
.step-tl{display:flex;flex-direction:column;align-items:center;padding:0 8px 0;position:relative;z-index:1}
.step-num{width:38px;height:38px;border-radius:50%;border:2px solid rgba(31,200,214,.45);background:#071422;display:flex;align-items:center;justify-content:center;font-family:'JetBrains Mono',monospace;font-size:11px;font-weight:700;color:#1FC8D6;margin-bottom:20px;flex-shrink:0;position:relative;z-index:2;transition:border-color .25s,box-shadow .25s}
.step-tl:hover .step-num{border-color:rgba(31,200,214,.85);box-shadow:0 0 18px rgba(31,200,214,.22),0 0 0 4px rgba(31,200,214,.08);animation:glowPulse 2.4s ease-in-out infinite}
.step-card{background:linear-gradient(180deg,#0D1E30,#071422);border:1px solid #122840;border-radius:16px;padding:20px 16px;width:100%;flex:1;transition:border-color .25s,box-shadow .25s}
.step-tl:hover .step-card{border-color:rgba(31,200,214,.3);box-shadow:0 0 0 1px rgba(31,200,214,.08),0 8px 28px rgba(0,0,0,.32)}
@media(max-width:1100px){
  .steps-tl{grid-template-columns:repeat(3,1fr);row-gap:32px}
  .steps-tl::before{right:calc(100% / 3 / 2);left:calc(100% / 3 / 2)}
}
@media(max-width:680px){
  .steps-tl{grid-template-columns:1fr;row-gap:0;gap:0}
  .steps-tl::before{display:none}
  .step-tl{flex-direction:row;align-items:flex-start;gap:16px;padding:0 0 24px;position:relative}
  .step-tl:not(:last-child)::after{content:'';position:absolute;top:40px;left:19px;width:2px;bottom:0;background:linear-gradient(to bottom,rgba(31,200,214,.35),rgba(31,200,214,.06));z-index:0}
  .step-num{flex-shrink:0;margin-bottom:0;margin-top:2px;position:relative;z-index:2}
  .step-card{flex:1;z-index:1}
}

/* ── Section wave dividers ── */
.sec-wave{overflow:hidden;line-height:0;display:block;margin-bottom:-1px}
.sec-wave svg{display:block;width:100%}

/* ── CtaBand dual CTA ── */
.cta-band-row{display:flex;gap:14px;justify-content:center;margin-top:32px;flex-wrap:wrap}
@media(max-width:560px){.cta-band-row{flex-direction:column;align-items:center}}

/* ── Footer mobile centered ── */
@media(max-width:560px){
  .ftr-g{grid-template-columns:1fr!important;gap:24px 0!important;text-align:center}
  .ftr-logo{display:flex!important;flex-direction:column!important;align-items:center!important;padding-bottom:20px;border-bottom:1px solid #122840;margin-bottom:4px}
  .ftr-logo > div{justify-content:center!important}
  .ftr-contacts{grid-column:auto}
  .ftr-bottom{flex-direction:column!important;align-items:center!important;text-align:center!important;gap:10px!important}
  .ftr-bottom > div:last-child{justify-content:center!important}
}

/* ── Count-up stat number ── */
.stat-num{display:block;font-size:clamp(14px,1.5vw,20px);font-weight:900;color:#fff;letter-spacing:-.025em;font-variant-numeric:tabular-nums;transition:color .15s}
.stat-num-ink{display:block;font-size:clamp(22px,2.6vw,32px);font-weight:900;color:#0A2028;letter-spacing:-.025em;font-variant-numeric:tabular-nums}

/* ── Mobile wave — flatten first hero arch ── */
@media(max-width:820px){
  .wave-first svg{transform:scaleY(0.42);transform-origin:bottom}
}

/* ── prefers-reduced-motion ── */
@media(prefers-reduced-motion:reduce){
  *,::before,::after{animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.1ms!important}
}
`
